// import React, { useState, useEffect } from "react";
// import "./predocument.css";
// import { FaCloudUploadAlt } from "react-icons/fa";
// import { ImSpinner2 } from "react-icons/im"; // Spinner icon
// import axios from "axios";
// import { useParams } from "react-router";

// const initialDocuments = [
//   { id: "claim-form", name: "Final Invoice" },

// ];

// const initialAdditionalDocuments = [
//   { id: "document-1", name: "Document 1" },
//   { id: "document-2", name: "Document 2" },
//   { id: "document-3", name: "Document 3" },
// ];

// const InvoiceDocumentStatus = () => {
//   const { claimNumber } = useParams();
//   const [uploadedDocs, setUploadedDocs] = useState({});
//   const [uploadTimes, setUploadTimes] = useState({});
//   const [loadingDocs, setLoadingDocs] = useState(true);
//   const [uploadingDocIds, setUploadingDocIds] = useState([]); // track uploading documents
//   const [additionalDocuments, setAdditionalDocuments] = useState(initialAdditionalDocuments);

//   const checkDocumentExistence = async (docId) => {
//     try {
//       const blobName = `Pre-repair-documents/${claimNumber}_pre_${docId}`;
//       const response = await axios.post('/process_data/check_document_exists', { blobName });
//       return response.data.exists;
//     } catch (error) {
//       console.error('Error checking document existence:', error.message);
//       return false;
//     }
//   };

//   useEffect(() => {
//   const fetchExistingDocs = async () => {
//     const azureBaseUrl = 'https://caisdatahouse.blob.core.windows.net/insurance-inspection/';
//     const sasToken = 'sv=2022-11-02&ss=b&srt=sco&sp=rwdlacyx&se=2030-12-24T21:24:33Z&st=2023-12-24T13:24:33Z&spr=https&sig=Ytog9LRRNwVpscHMH5q3Q8F7v6U2Te5F6oU8%2F1WArio%3D';

//     const updatedDocs = {};

//     const checkAndAddDocs = async (docs) => {
//       for (const doc of docs) {
//         const blobName = `Pre-repair-documents/${claimNumber}_pre_${doc.id}`;
//         const exists = await checkDocumentExistence(doc.id);

//         if (exists) {
//           updatedDocs[doc.id] = `${azureBaseUrl}${blobName}?${sasToken}`;
//         }
//       }
//     };

//     await checkAndAddDocs(initialDocuments);
//     await checkAndAddDocs(initialAdditionalDocuments);

//     setUploadedDocs(updatedDocs);
//     setLoadingDocs(false); // ✅ stop loader once done
//   };

//   fetchExistingDocs();
// }, [claimNumber]);


//   const handleFileUpload = (event, docId) => {
//     const file = event.target.files[0];
//     if (!file) return;

//     const reader = new FileReader();
//     reader.onloadend = async () => {
//       const blobName = `Pre-repair-documents/${claimNumber}_pre_${docId}`;
//       const base64String = reader.result.split(',')[1];
//       const contentType = file.type; // e.g. 'application/pdf', 'image/jpeg'
//       console.log("95", contentType);

//       try {
//         setUploadingDocIds((prev) => [...prev, docId]);

//         const response = await axios.post('/process_data/upload-file', {
//           blobName,
//           fileContent: base64String,
//           contentType,
//         });


//         if (response.status === 200 || response.status === 201) {
//           // 👇 Construct the file URL immediately
//           const azureBaseUrl = 'https://caisdatahouse.blob.core.windows.net/insurance-inspection/';
//           const sasToken = 'sv=2022-11-02&ss=b&srt=sco&sp=rwdlacyx&se=2030-12-24T21:24:33Z&st=2023-12-24T13:24:33Z&spr=https&sig=Ytog9LRRNwVpscHMH5q3Q8F7v6U2Te5F6oU8%2F1WArio%3D';
//           const uploadedUrl = `${azureBaseUrl}${blobName}?${sasToken}`;
          
// setUploadedDocs((prev) => ({ ...prev, [docId]: uploadedUrl }));


//           // ✅ Call the backend API to update DB
//           await axios.post('/process_data/update_pre_repair_doc', {
//             claimNumber,
//           });
//         } else {
//           console.error('Upload failed with status:', response.status);
//           alert('Upload failed. Please try again.');
//         }
//       } catch (error) {
//         console.error('Error uploading PDF:', error.response?.data || error.message);
//         alert('Something went wrong during upload.');
//       } finally {
//         setUploadingDocIds((prev) => prev.filter((id) => id !== docId));
//       }
//     };

//     reader.readAsDataURL(file);
//   };

//   const addAdditionalDocument = () => {
//     const newDoc = {
//       id: `document-${additionalDocuments.length + 1}`,
//       name: `Document ${additionalDocuments.length + 1}`,
//     };
//     setAdditionalDocuments([...additionalDocuments, newDoc]);
//   };

//   const renderDocumentCard = (doc) => (
//     <div className="document-card" key={doc.id}>
//       <div className="text-content">
//         <p className="document-name">{doc.name}</p>
//         <p className={`document-date ${uploadTimes[doc.id] ? "visible" : ""}`}>
//           {uploadTimes[doc.id] || ""}
//         </p>
//       </div>

//       {uploadedDocs[doc.id] ? (
//         <button
//           className="action-btn preview"
//           onClick={() => window.open(uploadedDocs[doc.id], "_blank")}
//         >
//           Preview
//         </button>
//       ) : uploadingDocIds.includes(doc.id) ? (
//         <button className="action-btn uploading" disabled>
//           <ImSpinner2 className="spinner" /> Uploading...
//         </button>
//       ) : (
//         <>
//           <input
//             type="file"
//             id={doc.id}
//             style={{ display: "none" }}
//             onChange={(e) => handleFileUpload(e, doc.id)}
//           />
//           <button
//             className="action-btn upload"
//             onClick={() => document.getElementById(doc.id).click()}
//           >
//             <FaCloudUploadAlt /> Upload
//           </button>
//         </>
//       )}
//     </div>
//   );
// if (loadingDocs) {
//   return (
//     <div className="document-status-container loader-center">
//       <ImSpinner2 className="spinner" style={{ fontSize: 40, animation: "spin 1s linear infinite" }} />
//       <p>Fetching documents...</p>
//     </div>
//   );
// }
//   return (
//     <div className="document-status-container">
//       <div className="title-container">
//         <h2 className="title">Additional Documents</h2>
//         <img
//           src="https://www.iconpacks.net/icons/1/free-document-icon-901-thumb.png"
//           alt="Logo"
//           className="document-logo"
//         />
//       </div>

//       {/* <div className="documents-grid">
//         {initialDocuments.map(renderDocumentCard)}
//       </div> */}

//       {/* <h3 className="additional-title">Additional Documents</h3> */}
//       <div className="documents-grid">
//         {additionalDocuments.map(renderDocumentCard)}
//       </div>

//       <button className="upload-additional" onClick={addAdditionalDocument}>
//         Add Additional Document
//       </button>
//     </div>
//   );
// };

// export default InvoiceDocumentStatus;

import React, { useState, useEffect } from "react";
import "./predocument.css";
import { FaCloudUploadAlt } from "react-icons/fa";
import { ImSpinner2 } from "react-icons/im";
import axios from "axios";
import { useParams } from "react-router";

const initialDocuments = [
  { id: "claim-form", name: "Final Invoice" },
];

const initialAdditionalDocuments = [
  { id: "document-1", name: "Document 1" },
  { id: "document-2", name: "Document 2" },
  { id: "document-3", name: "Document 3" },
];

const InvoiceDocumentStatus = () => {
  const { claimNumber } = useParams();
  const [uploadedDocs, setUploadedDocs] = useState({});
  const [uploadTimes, setUploadTimes] = useState({});
  const [loadingDocs, setLoadingDocs] = useState(true);
  const [uploadingDocIds, setUploadingDocIds] = useState([]);
  const [additionalDocuments, setAdditionalDocuments] = useState(initialAdditionalDocuments);

  // ✅ Check document existence in S3 (backend returns signed URL if exists)
  const checkDocumentExistence = async (docId) => {
    try {
      const blobName = `Pre-repair-documents/${claimNumber}_pre_${docId}`;
      const response = await axios.post("/process_data/check_document_exists", { blobName });
      return response.data.exists ? response.data.url : null; // ✅ Return signed URL if exists
    } catch (error) {
      console.error("Error checking document existence:", error.message);
      return null;
    }
  };

  useEffect(() => {
    const fetchExistingDocs = async () => {
      const updatedDocs = {};
      const updatedTimes = {};

      const checkAndAddDocs = async (docs) => {
        for (const doc of docs) {
          const fileUrl = await checkDocumentExistence(doc.id);
          if (fileUrl) {
            updatedDocs[doc.id] = fileUrl;
            updatedTimes[doc.id] = new Date().toLocaleString();
          }
        }
      };

      await checkAndAddDocs(initialDocuments);
      await checkAndAddDocs(initialAdditionalDocuments);

      setUploadedDocs(updatedDocs);
      setUploadTimes(updatedTimes);
      setLoadingDocs(false);
    };

    fetchExistingDocs();
  }, [claimNumber]);

  const handleFileUpload = (event, docId) => {
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onloadend = async () => {
      const blobName = `Pre-repair-documents/${claimNumber}_pre_${docId}`;
      const base64String = reader.result.split(",")[1];
      const contentType = file.type;

      try {
        setUploadingDocIds((prev) => [...prev, docId]);

        // ✅ Upload file to S3 via backend
        const response = await axios.post("/process_data/upload-file", {
          blobName,
          fileContent: base64String,
          contentType,
        });

        if (response.status === 200 || response.status === 201) {
          const uploadedUrl = response.data.url; // ✅ Use signed URL returned from backend
          setUploadedDocs((prev) => ({ ...prev, [docId]: uploadedUrl }));
          setUploadTimes((prev) => ({ ...prev, [docId]: new Date().toLocaleString() }));

           const localDateTime = new Date()
    .toISOString()
    .slice(0, 19)
    .replace("T", " ");

  await axios.post("/process_data/update-prerepair-date-time", {
    claimNumber,
    dateTime: localDateTime
  });

          // ✅ Notify backend DB about the upload
          await axios.post("/process_data/update_pre_repair_doc", { claimNumber });
        } else {
          console.error("Upload failed with status:", response.status);
          alert("Upload failed. Please try again.");
        }
      } catch (error) {
        console.error("Error uploading document:", error.response?.data || error.message);
        alert("Something went wrong during upload.");
      } finally {
        setUploadingDocIds((prev) => prev.filter((id) => id !== docId));
      }
    };

    reader.readAsDataURL(file);
  };

  const addAdditionalDocument = () => {
    const newDoc = {
      id: `document-${additionalDocuments.length + 1}`,
      name: `Document ${additionalDocuments.length + 1}`,
    };
    setAdditionalDocuments([...additionalDocuments, newDoc]);
  };

  const renderDocumentCard = (doc) => (
    <div className="document-card" key={doc.id}>
      <div className="text-content">
        <p className="document-name">{doc.name}</p>
        <p className={`document-date ${uploadTimes[doc.id] ? "visible" : ""}`}>
          {uploadTimes[doc.id] || ""}
        </p>
      </div>

      {uploadedDocs[doc.id] ? (
        <button
          className="action-btn preview"
          onClick={() => window.open(uploadedDocs[doc.id], "_blank")}
        >
          Preview
        </button>
      ) : uploadingDocIds.includes(doc.id) ? (
        <button className="action-btn uploading" disabled>
          <ImSpinner2 className="spinner" /> Uploading...
        </button>
      ) : (
        <>
          <input
            type="file"
            id={doc.id}
            style={{ display: "none" }}
            onChange={(e) => handleFileUpload(e, doc.id)}
          />
          <button
            className="action-btn upload"
            onClick={() => document.getElementById(doc.id).click()}
          >
            <FaCloudUploadAlt /> Upload
          </button>
        </>
      )}
    </div>
  );

  if (loadingDocs) {
    return (
      <div className="document-status-container loader-center">
        <ImSpinner2 className="spinner" style={{ fontSize: 40, animation: "spin 1s linear infinite" }} />
        <p>Fetching documents...</p>
      </div>
    );
  }

  return (
    <div className="document-status-container">
      <div className="title-container">
        <h2 className="title">Additional Documents</h2>
        <img
          src="https://www.iconpacks.net/icons/1/free-document-icon-901-thumb.png"
          alt="Logo"
          className="document-logo"
        />
      </div>

      <div className="documents-grid">
        {additionalDocuments.map(renderDocumentCard)}
      </div>

      <button className="upload-additional" onClick={addAdditionalDocument}>
        Add Additional Document
      </button>
    </div>
  );
};

export default InvoiceDocumentStatus;
